import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./authentication/page404/page404.component";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { AuthGuard } from "./helpers/guards/auth.guard";
import { RoleTypeEnum } from "./enum/roles.enum";

const routes: Routes = [
	{
		path: "",
		redirectTo: "client/dashboard",
		pathMatch: "full",
	},
	{
		data: { expectedRole: [RoleTypeEnum.CLIENT_ROLE] },
		path: "client",
		component: MainLayoutComponent,
		canActivate: [AuthGuard],

		children: [
			{
				path: "",
				loadChildren: () =>
					import("./client/client.module").then((m) => m.ClientModule),				
			},
		],
	},
	{
		data: { expectedRole: [RoleTypeEnum.CLIENT_ROLE] },
		path: "reports",
		component: MainLayoutComponent,
		canActivate: [AuthGuard],

		children: [
			{
				path: "",
				loadChildren: () =>
					import("./reports/reports.module").then((m) => m.ReportsModule),
			},
		],
	},
	{
		data: { expectedRole: [RoleTypeEnum.ORGANIZATION_ROLE] },
		path: "admin",
		component: MainLayoutComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: "applications",
				loadChildren: () =>
					import("./applications/application.module").then(
						(m) => m.ApplicationTableModule
					),
			},
			{
				path: "",
				loadChildren: () =>
					import("./admin/dashboard-module/admin-dashboard.module").then(
						(m) => m.AdminDashboardModule
					),
			},
			{
				path: "client-listing",
				loadChildren: () =>
					import("./admin/clients/clients.module").then(
						(m) => m.AdminClientsModule
					),
			},
			{
				path: "sms",
				loadChildren: () =>
					import("./admin/clients/clients.module").then(
						(m) => m.AdminClientsModule
					),
			},
		],
	},
	{
		path: "",
		component: MainLayoutComponent,
		canActivate: [AuthGuard],
		children: [
			{
				path: "ui",
				loadChildren: () => import("./ui/ui.module").then((m) => m.UiModule),
			},
			{
				path: "profile",
				loadChildren: () =>
					import("./profile/profile.module").then((m) => m.ProfileModule),
			},
		],
	},
	{
		path: "authentication",
		component: AuthLayoutComponent,
		loadChildren: () =>
			import("./authentication/authentication.module").then(
				(m) => m.AuthenticationModule
			),
	},
	{ path: "page-not-found", component: Page404Component },
	{ path: "**", component: Page404Component },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
